import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import infoCircle from './images/info-circle.svg'
import { Fade, styled } from '@mui/material'

type InfoTooltipProps = {
  title: string
  customWidth?: boolean
}

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 135,
  },
})

const InfoTooltip = ({ title, customWidth = false }: InfoTooltipProps) => {
  return customWidth ? (
    <CustomWidthTooltip
      title={title}
      placement="top-end"
      disableInteractive
      enterDelay={0}
      leaveDelay={0}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 0 }}
    >
      <img
        src={infoCircle}
        alt="i with a circle around it"
        className="cursor-pointer"
      />
    </CustomWidthTooltip>
  ) : (
    <Tooltip
      title={title}
      placement="top-end"
      disableInteractive
      enterDelay={0}
      leaveDelay={0}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 0 }}
    >
      <img
        src={infoCircle}
        alt="i with a circle around it"
        className="cursor-pointer"
      />
    </Tooltip>
  )
}
export default InfoTooltip
